module.exports = __webpack_public_path__ + "static/media/store8.aa5d41a2.jpg";